<script>
	import { t } from '$lib/translations';
	import News from "/src/components/News.svelte"

	export let data;
</script>

<svelte:head>
	<title>{$t('news.news_title_page')}</title>
	<meta name="description" content="{$t('news.news_description_page')}">
</svelte:head>

<News {data}/>